// extracted by mini-css-extract-plugin
export default {"addNote":"AddNote_addNote__fu4rS","cancelSave":"AddNote_cancelSave__gxODH","descriptionIcon":"AddNote_descriptionIcon__t6Yxb","iconImage":"AddNote_iconImage__kRPWo"};